import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller, useForm } from "react-hook-form";
import { Box, Button, TextField, Typography } from '@material-ui/core';
import CustomIcon from "../../core/custom-icon";

export interface DashboardExpertsListAddProps {
  cancel: () => void;
  confirm: (email: string) => void;
}

interface ExpertAddForm {
  email: string;
}

export const DashboardExpertsListAdd = (props: DashboardExpertsListAddProps) => {
  
  const intl = useIntl();

  const { control, handleSubmit, errors } = useForm<ExpertAddForm>();
  
  const onSubmit = (data: ExpertAddForm) => {
    props.confirm(data.email);
  }

  return (
    <Box bgcolor='secondary.main'
         color='common.white'
         px={{xs: 2, md: 3}}
         pb={{xs: 2, md: 3}}
    >
      <Box textAlign='right' mr={{xs: -2, md: -3}}>
        <Button color='secondary'
                onClick={props.cancel}
                endIcon={
                  <CustomIcon iconname='erase' />
                }
        >
          <FormattedMessage id='DashboardExpertsAddCancel' />
        </Button>
      </Box>

      <Typography component='h3' variant='h4'>
        <FormattedMessage id='DashboardExpertsAdd' />
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        
        {/* @TODO REFACTORING email validation */}
        <Controller
          as={<TextField
            className='form--white'
            margin='normal'
            fullWidth
            InputLabelProps={{
              className: 'form--white'
            }}
            InputProps={{
              className: 'form--white',
              type: 'email'
            }} />
          }
          name='email'
          control={control}
          rules={{
            pattern: {
              value:  	
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // @TODO REFACTORING improve email validation
              message: intl.formatMessage({id: 'DashboardExpertsAddEmailInvalid'})
            }
          }}
          label={intl.formatMessage({id: 'DashboardExpertsAddEmail'})}
          defaultValue=''
        />
        {errors.email && <span >{errors.email.message}</span>}
        <Box textAlign='right' mt={2}>
          <Button type='submit' className='button--white'>
            <FormattedMessage id='DashboardExpertsAddConfirm' />
          </Button>
        </Box>
      </form>
    </Box>
  );
};
